module.exports = __webpack_public_path__ + "img/1559482411.bca544b6.jpg";